import { Link } from 'react-router-dom';

import { Container } from '@sshop/ui';

export function NotFoundPage() {
  return (
    <Container size="md" className="py-20 text-center">
      <p className="text-sm font-medium text-accent">404</p>
      <h1 className="mt-2 text-4xl font-semibold">Page not found</h1>
      <p className="mt-4 text-fg-secondary">The page you are looking for does not exist.</p>
      <Link to="/" className="mt-6 inline-block text-accent hover:underline">
        Go home
      </Link>
    </Container>
  );
}
